<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    @media screen and (min-width: 640px) {
        body {
            margin: 0;
            min-width: 1200px;
        }
    }

    @media screen and (max-width: 640px) {
        body {
            margin: 0;
            width: 100%;
        }
    }
</style>